import { render, staticRenderFns } from "./Login365.vue?vue&type=template&id=40f6ff38&lang=true&"
import script from "./Login365.vue?vue&type=script&lang=js&"
export * from "./Login365.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports